export default __webpack_public_path__ + "static/media/CryptoStealer.7fa9190e.png";